import { mark as orginalMark, getMarkerTime } from '@ms/odsp-utilities/lib/performance/PerformanceMarker';
import { RUMOneLogger } from '@ms/odsp-utilities/lib/logging/rumone/RUMOneLogger';

/**
 * @internal
 */
export interface IMarker {
    start: string;
    end: string;
}

/**
 * @internal
 */
export interface IItemsViewPerfMarkers {
    authToken: IMarker;
    itemsView: IMarker;
    dataFetch: IMarker;
    appStart: IMarker;
    singleItemFetch: IMarker;
    render: IMarker;
}

/**
 * @internal
 */
export const itemsViewPerfMarkers: IItemsViewPerfMarkers = {
    authToken: {
        start: 'Items-View.authTokenRequest.start',
        end: 'Items-View.authTokenRequest.end'
    },
    itemsView: {
        start: 'Items-View.Start',
        end: 'Items-View.End'
    },
    dataFetch: {
        start: 'Items-View.DataFetch.Start',
        end: 'Items-View.DataFetch.End'
    },
    appStart: {
        start: 'Items-View.AppStart',
        end: 'Items-View.AppStart.End'
    },
    singleItemFetch: {
        start: 'Items-View.SingleItemFetch.Start',
        end: 'Items-View.SingleItemFetch.End'
    },
    render: {
        start: 'Items-View.Render.Start',
        end: 'Items-View.Render.End'
    }
};

/**
 * @internal
 */
export const PerfMark = {
    mark: (name: string, limit?: number) => {
        // when external app marks itemsView.start, reset RUMOne to start a new measurement cycle
        if (name === itemsViewPerfMarkers.itemsView.start) {
            const rumOne: RUMOneLogger = RUMOneLogger.getRUMOneLogger();
            if (!rumOne.isRunning()) {
                rumOne.resetLogger();
            }
        }
        orginalMark(name, limit);
    },
    getMarkerTime: getMarkerTime
};
